import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';

export type BusinessType = {
  id: number | null;
  name: string;
};

export type BusinessesListResponseType = BusinessType[];

export const useGetBusinessesList = (
  options: QueryOptions<BusinessesListResponseType, AxiosError<ApiError>> = {}
) =>
  useQuery({
    queryFn: async (): Promise<BusinessesListResponseType> => {
      const { data } =
        await api.get<ApiResponse<BusinessesListResponseType>>(
          `/business/list`
        );

      return data.data;
    },
    queryKey: ['business'],
    ...options,
  });
